import { axiosInstance } from 'src/services/axiosInstance'
import { GET_TASKS } from '../constants'

export const getTasksList = async () => {
	const { data } = await axiosInstance.get(GET_TASKS)
	return data
}
